<template>
  <div class="pages" :style="isShowPageTitle == false ? 'padding: 0' :''">
    <div v-if="isShowPageTitle" class="page-column-name">{{ $route.meta.title }}</div>
    <!-- <div class="pages-content"> -->
      <jd-form
        :form-info="formThir12"
        :isreData="true"
        :emitReset="true"
        @search="searchInkind"
        @reset="resetForm"
        ref="export_fun_swRef"
        class="mb16"
      >
      </jd-form>
      <div class="flex-spc-x mb12" style="margin-top: 15px">
          <jd-button @click="addCrowd(47)">按查询结果生成人群</jd-button>
          <jd-button type="text" @click="exportFn" v-preventReClick
            >导出</jd-button
          >
      </div>
      <jd-table
            :loading="loading"
            :tableData="exchangeListTwelve"
            :pageInfo="{
              pageSize: formList.size,
              pageNum: formList.current,
              total: totalInkind,
            }"
            @handlePage="handlePageExchangeTwelve"
            rowKey="id"
          >
            <template slot="empty">
              <div>
                <img
                  src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png"
                />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column prop="memberNick" label="用户昵称" >
            </el-table-column>
            <el-table-column
              :prop="chaosParams"
              :label="`用户${grayText}`"
            >
            </el-table-column>
            <el-table-column prop="activityName" label="关联活动"> </el-table-column>
            <el-table-column prop="prizeTypeStr" label="奖品类型"> </el-table-column>
            <el-table-column prop="prizeName" label="奖品名称" >
            </el-table-column>
            <el-table-column prop="bidPoints" label="成交价格" >
            </el-table-column>
            <el-table-column prop="passTime" label="成交时间" >
            </el-table-column>
            <el-table-column prop="payStatusStr" label="支付状态" >
            </el-table-column>
            <el-table-column prop="payTime" label="支付时间" >
            </el-table-column>
            <el-table-column prop="payDeadline" label="支付截止时间" >
            </el-table-column>
      </jd-table>

    <!-- 录入快递单号弹窗 -->
    <jd-dialog
      title="录入快递单号"
      width="420px"
      :visible.sync="enterCoutierNumShow"
      @close="blankEnterCoutierNum"
      :append-to-body="true"
      class="enter_coutier_num_dialog"
    >
      <el-form
        :model="enterCoutierFrom"
        label-width="86px"
        class="new-input-box"
      >
        <el-form-item label="快递单号：">
          <el-input
            placeholder=""
            v-model="enterCoutierNum"
            style="width: 250px"
            @keydown.native="clearInput"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <jd-button
          type="blue"
          style="margin-left: 8px"
          @click="enterCoutierSubmit"
          >确定</jd-button
        >
        <jd-button @click="blankEnterCoutierNum">取消</jd-button>
      </template>
    </jd-dialog>
    <!-- 批量标记发货弹窗 -->
    <jd-dialog
      title="批量发货"
      width="580px"
      :visible.sync="physicalBatchShipmentShow"
      @close="physicalBatchShipmentClose"
      :isShowSure="false"
      :isShowCancel="false"
      :append-to-body="true"
      class="physical_batch_shipment_dialog"
    >
      <el-form
        :model="physicalBatchShipmentFrom"
        label-width="120px"
        class="new-input-box"
      >
        <el-form-item label="上传文件：">
          <el-upload
            :before-upload="beforeUploadFile"
            :on-success="handleUpload"
            :show-file-list="false"
            class="upload-demo"
            :drag="true"
            multiple
            with-credentials
            :action="'/jd-hd-web/lockRight/markingSendStatusBatch/allActivities/fileUpload'"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label=" ">
          <jd-button type="blue" @click="handleDownloadTemplate"
            >下载模板</jd-button
          >
        </el-form-item>
        <el-form-item label=" " v-if="isShow">
          <p>
            导入成功{{ downloadResData.successNum || 0 }}条，导入失败{{
              downloadResData.failNum || 0
            }}条，导入失败相关用户昵称：
          </p>
          <div class="mlt12 download-box">
            <div
              class="downloaditem"
              v-for="(item, index) in downloadUserList"
              :key="index"
            >
              {{ index + 1 + ". " }}{{ item }}
            </div>
          </div>
        </el-form-item>
      </el-form>
    </jd-dialog>
   <!-- 生成人群 -->
    <crowdDialog
      v-if="isShowCrowdDialog"
      :isShowCrowdDialog="isShowCrowdDialog"
      :searchForm="crowCondition"
      :activityType="activityType"
      :source="source"
      :defaultValue="hasDefaultValue"
      :defaultValueText="defaultValueText"
      @close="crowdClose"
    />
     <generate
      :control="control1"
      v-if="control1"
      @transData="(val) => (control1 = val)"
      @transData1="getphone1"
    ></generate>
  </div>
</template>

<script>
import {
  signIssuance,
  getAllGoodsRecords,
  markingSendStatusLockRight,
  dealRecords,
  exportDealRecords
} from "@/api/jhk/integralCenter/PointActivityAnalyticController";
import selectActivity from "@/components/select-activity";
import crowdDialog from "@/views/interactiveMarketing/activity/crowd-Dialog.vue";
import generate from "@/components/generate_report.vue";
export default {
  name: "gift_list",
  props: {
    isShowPageTitle: {
      type: Boolean,
      default: true,
    },
    activityType: {
      type: [Number , String],
      default: '',
    }
  },
  components: {
    selectActivity,
    crowdDialog,
    generate
  },
  computed: {
    // 1: 京获客旗舰版
    softType() {
      return this.$store.getters.loginUserInfo.yunZhouOtherType || '';
    },
    crowCondition() {
      return this.formList;
    },
    grayId() {
      return this.$store.getters.loginUserInfo.isGray ? 'xid' : 'pin'
    },
    grayText() {
      return this.$store.getters.loginUserInfo.isGray ? 'xid' : 'pin（加密）'
    },
    chaosParams() {
      return this.$store.getters.loginUserInfo.isGray ? 'chaosXid' : 'chaosPin'
    },
  },
  created() {
      this.buriedPoint(1, "积分竞拍", "互动管理", "互动活动");
    if(this.activityType){
     this.activityObj.activityType = this.activityType;
    }
  },
  data() {
    return {
      exchangeListTwelve:[],
      control1: false,
      defaultValueText: "",
      hasDefaultValue: false,
      source: "",
      isShowCrowdDialog: false,
      formThir12: [
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入用户昵称",
        },
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户PIN",
        },
        {
          label: "关联活动：",
          prop: "activityName",
          type: "Input",
          placeholder: "请输入关联活动",
        },
        {
          label: "支付状态：",
          prop: "payStatus",
          type: "Select",
          options: [
            { label: "全部", value: null },
            { label: "已支付", value: 1 },
            { label: "待支付", value: 0 },
            { label: "逾期未支付", value: 2 }
          ],
        },
        {
          label: "成交时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "passTimeStart",
          endKey: "passTimeEnd",
          defalutLimit: true,
        },
        {
          label: "支付时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "payTimeStart",
          endKey: "payTimeEnd",
          defalutLimit: true,
        },
      ],
      isShow: false,
      physicalBatchShipmentFrom: {},
      physicalBatchShipmentShow: false,
      // 控制录入快递单号弹窗
      enterCoutierNumShow: false,
      // 快递单号
      enterCoutierNum: "",
      // 弹窗表单标识
      enterCoutierFrom: {},
      // 录入快递单号当前行数据存储
      enterCoutierRowData: {},

      // 实物奖品名单
      inkindTable: [],
      totalInkind: 0,
      formList: {
        pin: "",
        memberNick: "",
        activityName: "",
        payStatus: "",
        payTimeEnd: "",
        payTimeStart: "",
        passTimeStart: "",
        passTimeEnd: "",
        current: 1,
        size: 10,
      },
      loading: false,
      activityList: [
        {
          value: 1,
          label: "日历签到",
        },
        {
          value: 4,
          label: "关注店铺有礼",
        },
        {
          value: 17,
          label: "首单专享礼",
        },
        {
          value: 16,
          label: "下单有礼",
        },
        {
          value: 19,
          label: "下单抽奖",
        },
        {
          value: 18,
          label: "复购有礼",
        },
        {
          value: 34,
          label: "加购有礼",
        },
        {
          value: 36,
          label: "打榜有礼",
        },
        {
          value: 27,
          label: "预售有礼",
        },
        {
          value: 28,
          label: "预售抽奖",
        },
        {
          value: 8,
          label: "幸运抽奖",
        },
        {
          value: 7,
          label: "完善信息有礼",
        },
        {
          value: 20,
          label: "评价有礼",
        },
        {
          value: 3,
          label: "每日限时抢",
        },
        {
          value: 22,
          label: "天降红包雨",
        },
        {
          value: 23,
          label: "欢乐娃娃机",
        },
        {
          value: 24,
          label: "大家来找茬",
        },
        {
          value: 5,
          label: "邀请开卡有礼",
        },
        {
          value: 6,
          label: "邀请关注有礼",
        },
        {
          value: 21,
          label: "裂变神券",
        },
        {
          value: 31,
          label: "超级裂变券",
        },
        {
          value: 39,
          label: "生日有礼",
        },
        {
          value: 41,
          label: "晒单有礼",
        },
        {
          value: 43,
          label: "N元锁权",
        },
        {
          value: 44,
          label: "会员升级礼",
        },
        {
          value: 46,
          label: "满额有礼",
        },
        {
          value: 45,
          label: "锁权有礼",
        },
        {
          value: 47,
          label: "调查问卷",
        },
        {
          value: 48,
          label: "定时开奖",
        },
        {
          value: 50,
          label: "情书贺卡",
        },
        {
          value: 51,
          label: "0元试用",
        },
        {
          value: 52,
          label: "试用回购礼",
        },
        {
          value: 53,
          label: "购物打卡",
        },
        {
          value: 62,
          label: "集卡有礼",
        },
        {
          value: 64,
          label: "组队瓜分奖品",
        },
        {
          value: 65,
          label: "粉丝打卡",
        },
        {
          value: 66,
          label: "入会有礼",
        },
        {
          value: 67,
          label: "销售打榜",
        },
        {
          value: 68,
          label: "会员成长计划",
        },
        {
          value: 69,
          label: "拼团砍价",
        },
        {
          value: 70,
          label: "积分竞拍",
        },
        {
          value: 77,
          label: "购物车锦鲤",
        },
      ],
      activityObj: {
        activityType: "",
        activityId: "",
      },
      physicalBatchShipmentShow: false,
      downloadResData: {
        successNum: 0,
        failNum: 0,
      },
    };
  },
  watch: {
    grayId: {
      handler(val) {
        this.formThir12.forEach((item) => {
          if(item.prop=='pin') {
            item.label = `用户${val}；`
            item.prop = val
            item.placeholder = item.placeholder.replace(/pin/ig,val)
          }
        })
      },
      immediate: true,
    },
  },
  mounted() {
    this.formList[this.grayId] = this.formList[this.grayId] || ""
    this.getList();
  },
  methods: {
      handlePageExchangeTwelve(val) {
        this.formList.size = val.pageSize;
        this.formList.current = val.pageNum;
        this.getList();
      },
      async exportFn() {
         this.control1 = true;
      },
      addCrowd(val) {
      // 如果版本为京获客旗舰版需要校验用户时候有该按钮权限
      if (this.softType == 1 && !this.$store.getters.isJhkPlatformSeller) {
        return this.$message.warning("您不满足使用该功能，请联系专属客服了解~")
      }
      this.source = val;
      this.isShowCrowdDialog = true;
      this.hasDefaultValue = true;
      this.defaultValueText = "成交记录";
    },
    crowdClose() {
      this.isShowCrowdDialog = false;
      // 关闭时重置
      if (this.hasDefaultValue) {
        this.hasDefaultValue = false;
        this.defaultValueText = "";
      }
    },
    getphone1(exportRemark) {
        var formDate = this.formList;
        const params = {
          current: formDate.current,
          size: formDate.size,
          activityName: formDate.activityName ? formDate.activityName : "",
          payStatus: formDate.payStatus ? formDate.payStatus : "",
          payTimeEnd: formDate.payTimeEnd ? formDate.payTimeEnd : "",
          payTimeStart: formDate.payTimeStart ? formDate.payTimeStart : "",
          memberNick: formDate.memberNick ? formDate.memberNick : "",
          passTimeStart: formDate.passTimeStart ? formDate.passTimeStart : "",
          passTimeEnd: formDate.passTimeEnd ? formDate.passTimeEnd : "",
          exportRemark,
        }
        params[this.grayId] = params[this.grayId] || ""
        exportDealRecords(params).then((res) => {
          if(res.code == 1){
            this.control1 = true;
          }else{
            this.$message.error(res.message);
          }
        })
    },
    resetForm(val) {
      this.formList.activityName = "";
      this.formList.payStatus = "";
      this.formList.payTimeEnd = "";
      this.formList.payTimeStart = "";
      this.formList.passTimeStart = "";
      this.formList.passTimeEnd = "";
      this.formList[this.grayId] = "";
      this.formList.memberNick = "";
      this.formList.current = 1;
      this.formList.size = 10;
      this.getList();
    },
    getList() {
      this.loading = true;
      if(this.activityType){
        this.formList.activitySubTypes = this.activityType;
      }
      dealRecords(this.formList)
        .then((res) => {
          this.loading = false;
          if (res.code == 1) {
            this.exchangeListTwelve = res.data.records || [];
            this.totalInkind = res.data.total || 0;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleDownloadTemplate() {
      let url =
        "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/%E6%89%B9%E9%87%8F%E5%8F%91%E8%B4%A7%E6%A8%A1%E6%9D%BF2.xlsx";
      let fileName = "实物奖品名单批量发货模板.xlsx";
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      elem.setAttribute("download", fileName);
      document.body.appendChild(elem);
      elem.click();
    },
    // 上传文件回调
    handleUpload(res) {
      this.isShow = true;
      // 上传文件
      if (res.code == 0) {
        this.$message.error(res.message);
      } else if (res.code == 1) {
        this.downloadResData = res.data;
        this.downloadUserList = res.data.failUserName;
        this.getList();
      }
    },
    // 上传文件处理
    beforeUploadFile(file) {
      console.log(file, "5433");
      if (
        file.type !=
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        file.type != "application/vnd.ms-excel" &&
        file.type != "text/csv"
      ) {
        this.$message.warning("请上传正确格式的文件");
        return false;
      }
    },
    physicalBatchShipmentClose() {
      this.physicalBatchShipmentShow = false;
      this.downloadResData = {};
      this.downloadUserList = [];
    },
    markIss(row) {
      signIssuance({ id: row.recordId || row.id }).then((res) => {
        if (res && res.code == 1) {
          this.$message.success(res.message);
          this.getList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //标记发货
    changeShip(row) {
      this.$confirm("是否标记为发货?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
        customClass: "reverse-buttons",
      }).then(() => {
        this.markIss(row);
      });
    },
    // 取消发货
    cancelShip(row) {
      this.$confirm("是否取消发货?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
        customClass: "reverse-buttons",
      }).then(() => {
        this.markIss(row);
      });
    },
    // 监听录入快递单号按钮
    handleEnterCoutierNum(row) {
      this.enterCoutierNum = row.billCode;
      this.enterCoutierRowData = row;
      this.$forceUpdate();
      // 打开弹窗
      this.enterCoutierNumShow = true;
    },
    // 置空录入快递单号输入框并关闭弹窗
    blankEnterCoutierNum() {
      this.enterCoutierNum = "";
      // 清除当前行存储数据
      this.enterCoutierRowData = {};
      this.enterCoutierNumShow = false;
      this.sendOutGoodsShow = false;
    },
    clearInput(e) {
      let key = e.key;
      if (key === "e" || key === "E" || key === "+" || key === "-") {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    // 录入快递单号提交
    enterCoutierSubmit() {
      let params = {
        billCode: this.enterCoutierNum,
        isUpdatePrizeStatus: true,
        id: this.enterCoutierRowData.id,
      };
      markingSendStatusLockRight(params)
        .then((res) => {
          if (res.code == 1) {
            this.getList();
            this.blankEnterCoutierNum();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {
          this.$message.error("录入快递单号失败");
        });
    },
    // 实物奖品搜索
    searchInkind(val) {


      // this.formList.activitySubTypes = this.activityObj.activityType;
      // this.formList.activityIds = this.activityObj.activityId;

      this.formList.activityName = val.activityName;

      this.formList.payStatus = val.payStatus;

      this.formList.payTimeEnd = val.payTimeEnd;
      this.formList.payTimeStart = val.payTimeStart;

      this.formList.passTimeStart = val.passTimeStart;
      this.formList.passTimeEnd = val.passTimeEnd;

      this.formList[this.grayId] = val[this.grayId];
      this.formList.memberNick = val.memberNick;
      this.formList.current = 1;
      this.getList();
    },
    // 分页处理
    handlePageInkind(page) {
      this.formList.current = page.pageNum;
      this.formList.size = page.pageSize;
      this.getList();
    },
    // 批量标记发货
    batchMarkForShipment() {
      // 批量标记发货逻辑
      this.physicalBatchShipmentShow = true;
    },
    // 跳转到商品管理
    handleToGoods(id) {
      let routeUrl = this.$router.resolve({
        path: "/tool/prizeCenter/goodsManagement",
        query: {
          id,
          tabActive: 1,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.pages {
  background-color: #fff;
  padding: 16px;
  height: 100%;
  border-radius: 8px;
  // .pages-content {
  //   height: 100%;
  //   background: #ffffff;
  //   border-radius: 16px 16px 0 0;
  //   padding: 0 20px;
  //   overflow: hidden;
  //   padding: 20px;
    .goodsInfo {
      padding: 5px 0;
      display: flex;
      align-items: center;
      &_logo {
        display: flex;
        width: 80px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
          width: 70px;
          border-radius: 4px;
        }
      }
      &_text {
        flex: 1;
        color: #666666;
        cursor: pointer;
        margin-left: 5px;
        a {
          color: #666666;
          margin-top: 5px;
        }
      }
    }
    .physical_batch_shipment_dialog {
      .upload-demo {
        /deep/ .el-upload .el-upload-dragger {
          width: 250px;
        }
      }
      .download_template_box {
        position: absolute;
        right: 24px;
        top: 17%;
      }
      .downloadMsgBox {
        width: 100%;
        min-height: 100px;
      }
      .physical_batch_shipment_dialog_floor {
        text-align: right;
        width: 100%;
      }
    }
    //  为右侧固定列添加更高的z-index，确保操作列显示在其他列上方
     /deep/ .el-table__fixed-right {
        z-index: 99;
      }
  // }
  .mlt12 {
    margin-left: 24px;
  }
  .download-box {
    max-height: 300px;
    overflow-y: auto;
  }
  .downloaditem {
    line-height: 24px;
  }
}
</style>
